module.exports = __webpack_public_path__ + "static/media/advanced-disposal-header.60c91c50.png";